import { getCookie, setCookie } from '../cookies';

// Для промо бара в хедере (partials/promo)
function checkLine() {
    if ($('.under-header-link').length) {
        if (!getCookie("cookieLine")) {
            $(".under-header-link").addClass("show");
            $("body").addClass("gap");
        } else {
            $(".under-header-link").removeClass("show");
            $("body").removeClass("gap");
        }
    }
}

$(() => {
    checkLine();

    // Для промо бара
    $(document).on("click", ".under-header-cross", function () {
        setCookie("cookieLine", "hide");
        checkLine();
    });
});
